import React from 'react';
import styles from './SingleMetricWithDetailAndIconCard.module.scss';

interface SingleMetricWithDetailAndIconCardProps {
  icon: string;
  title: string;
  subtitle: string;
  metric: string;
  backgroundColor: string;
  textColor: string;
  metricColor: string;
}

const SingleMetricWithDetailAndIconCard: React.FC<
  SingleMetricWithDetailAndIconCardProps
> = ({
  icon,
  title,
  subtitle,
  metric,
  backgroundColor,
  textColor,
  metricColor,
}) => {
  return (
    <div className={styles.card} style={{ backgroundColor }}>
      <img src={icon} alt="Icon" className={styles.icon} />
      <div className={styles.textContainer}>
        <span className={styles.title} style={{ color: textColor }}>
          {title}
        </span>
        <span className={styles.subtitle} style={{ color: textColor }}>
          {subtitle}{' '}
          <span className={styles.metric} style={{ color: metricColor }}>
            {metric}
          </span>
        </span>
      </div>
    </div>
  );
};

export default SingleMetricWithDetailAndIconCard;
